import { useGetExternalLocations } from '@/hooks/dbui/useGetExternalLocations';
import { FormTypeahead, FormTypeaheadProps } from '@/components/form/form';

export type ExternalLocationsTypeaheadProps = Omit<
  FormTypeaheadProps,
  'items' | 'minChars'
>;

export default function ExternalLocationsTypeahead({
  ...props
}: ExternalLocationsTypeaheadProps) {
  const { data: { locations = [] } = {} } = useGetExternalLocations();

  return (
    <FormTypeahead
      items={locations?.map((location) => location.url) || []}
      minChars={0}
      {...props}
    />
  );
}
